import { VuexModule, Module, Mutation, Action } from 'vuex-module-decorators'
import Apis from '@/Apis/_'
import { ModalContestacaoMedica, ContestacaoMedica, ContestacaoMedicaMensagem, TipoEnvioMensagemEnum } from '@/types/_'

@Module({ namespaced: true, name: 'ContestacaoMedicaStore' })
export default class ContestacaoMedicaStore extends VuexModule {
  modal: ModalContestacaoMedica = {
    contestacaoMedica: false,
  }

  public contestacaoMedicaDefault = {
    nomePaciente: '',
    medicoSolicitanteNome: '',
    protocoloOperadora: '',
    protocoloOPME: '',
    autorizacaoValidade: '',
    autorizacaoObservacao: '',
    contestacaoId: '',
    mensagens: [],
  }

  solicitacaoId: string = ''
  tipoEnvioMensagem: string = ''
  contestacaoMedica: ContestacaoMedica = { ...this.contestacaoMedicaDefault }

  @Action
  async enviarMensagem(params: any) {
    const action = this.contestacaoMedica.contestacaoId ? 'enviarMensagem' : 'abrirContestacao'
    const mensagem = action === 'enviarMensagem'
      ? { mensagens: [{ ...params.contestacaoMedicaMensagem }] }
      : [params.contestacaoMedicaMensagem]

    const request = await Apis.Agendamento.ContestacaoMedicaApi[action](this.solicitacaoId, mensagem)
    if (request.success) {
      if (request.data && request.data.solicitacao) {
        const contestacao = await this.getContestacaoMedica(this.solicitacaoId)
        if (contestacao.success) {
          this.context.commit('setContestacaoMedica', contestacao.data)
        }
      } else {
        const { contestacaoMedicaMensagem } = params
        contestacaoMedicaMensagem.id = request.data.mensagens[0].id
        this.context.commit('setContestacaoMedicaMensagem', contestacaoMedicaMensagem)
      }
    }
    return request
  }

  @Action
  async uploadDocumento(params: any) {
    const request = await Apis.Agendamento.ContestacaoMedicaApi.uploadDocumento(params.hospitalId, params.formData)
    return request
  }

  @Action
  async getContestacaoMedica(solicitacaoId: string) {
    this.context.commit('setSolicitacaoId', solicitacaoId)
    const request = await Apis.Agendamento.ContestacaoMedicaApi.get(solicitacaoId)

    if (request.success) {
      this.context.commit('setContestacaoMedica', request.data)
    }
    return request
  }

  @Action
  async aceitarContestacao() {
    const request = await Apis.Agendamento.ContestacaoMedicaApi.aceitarContestacao(this.solicitacaoId)
    return request
  }

  @Action
  async recusarContestacao() {
    const request = await Apis.Agendamento.ContestacaoMedicaApi.recusarContestacao(this.solicitacaoId)
    return request
  }

  @Action
  async aceitarRecusaDeContestacao() {
    const request = await Apis.Agendamento.ContestacaoMedicaApi.aceitarRecusaDeContestacao(this.solicitacaoId)
    return request
  }

  @Mutation
  setShowModalContestacaoMedica(value: boolean) {
    this.modal.contestacaoMedica = value
  }

  @Mutation
  setContestacaoMedica(contestacao: ContestacaoMedica) {
    this.contestacaoMedica = contestacao
  }

  @Mutation
  async setContestacaoMedicaMensagem(value: ContestacaoMedicaMensagem) {
    this.contestacaoMedica.mensagens.push(value)
  }

  @Mutation
  setTipoEnvioMensagem(tipoEnvio: TipoEnvioMensagemEnum) {
    this.tipoEnvioMensagem = tipoEnvio
  }

  @Mutation
  setSolicitacaoId(solicitacaoId: string) {
    this.solicitacaoId = solicitacaoId
  }

  @Mutation
  clearContestacaoMedica() {
    this.contestacaoMedica = { ...this.contestacaoMedicaDefault }
  }
}
